const ssrSafeWindow = typeof window === 'undefined' ? {} : window;
const ScreenInfo =
  ({innerWidth = 0, innerHeight = 0, devicePixelRatio = 1}) =>
  ({children}) =>
    children({innerWidth, innerHeight, devicePixelRatio});

export default ScreenInfo(ssrSafeWindow);
